
import { Component, Vue, Watch, Prop, Ref, Emit } from "vue-property-decorator";
import { namespace, Getter, Action } from "vuex-class";
import UploadFileButton from "@/components/mobile/dispatch/UploadFileButton.vue";
import MessagesList from "./MessagesList.vue";
import ChatFunction from "./ChatFunction.vue";

const GuardChat = namespace("guardChat");
const Mobile = namespace("mobile");

@Component({
	components: { UploadFileButton, MessagesList, ChatFunction }
})
export default class ChatContainer extends Vue {
	@Mobile.State(state => state.UserSharedEventIds) userSharedEventIds: number[];

	@GuardChat.Getter("getNumberOfUnread") getNumberOfUnread: (eventId: number) => number;	
	@GuardChat.State(state => state.activeMessagesEventId) eventId: number;
	@GuardChat.Mutation setMessagesEventId: (eventId: number) => void;

	@Ref() readonly chatContainer: HTMLDivElement;
	@Ref() readonly messagesList: MessagesList;

	private chatExpanded = false;
	private currentChatIteration: number = 0;
	private pollTimeout = null;

	private async mounted() {
		const index = this.userSharedEventIds.findIndex(x => x === this.eventId);
		if (index > -1) {
			this.currentChatIteration = index;
		}

		this.messagesList.restoreScrolling();
	}

	private onChatCollapse() {
		this.chatExpanded = false;
		this.chatExpandToggle();
		this.messagesList.storeScrolling();
	}

	@Emit("chat-expand-toggle")
	public chatExpandToggle() {
		return this.chatExpanded;
	}

	onPrevious() {
		if (this.currentChatIteration > 0) {
			this.currentChatIteration = this.currentChatIteration - 1;
		}

		this.setMessagesEventId(this.userSharedEventIds[this.currentChatIteration]);
		this.messagesList.restoreScrolling();
	}

	onNext() {
		if (this.currentChatIteration < this.userSharedEventIds.length - 1) {
			this.currentChatIteration = this.currentChatIteration + 1;
		}

		this.setMessagesEventId(this.userSharedEventIds[this.currentChatIteration]);
		this.messagesList.restoreScrolling();
	}
}
